import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title p-grid" }
const _hoisted_2 = { class: "title p-col-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title p-col-4 p-text-right" }, " RTG: ", -1)
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "week p-col-12" }, " Ultima semana: ", -1)
const _hoisted_6 = { class: "p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_TeacherInfoCard = _resolveComponent("TeacherInfoCard")!
  const _component_TutorInfoCard = _resolveComponent("TutorInfoCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1),
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass([
              'p-col-1',
              $props.value >= 4.7 ? 'positive-rate' : 'negative-rate'
            ])
    }, _toDisplayString(isNaN($props.value) ? '-' : $setup.truncate($props.value)), 3),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Divider, { class: "divider" })
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      ($props.teacher)
        ? (_openBlock(), _createBlock(_component_TeacherInfoCard, {
            key: 0,
            teachers: $props.summary,
            isFinishied: $props.isFinishied,
            teachersFinishied: $props.teachersWithRating
          }, null, 8, ["teachers", "isFinishied", "teachersFinishied"]))
        : (_openBlock(), _createBlock(_component_TutorInfoCard, {
            key: 1,
            tutors: $props.summary,
            isFinishied: $props.isFinishied,
            tutorsFinishied: $props.tutorsWithRating
          }, null, 8, ["tutors", "isFinishied", "tutorsFinishied"]))
    ])
  ]))
}